const CONSENT_STORAGE_KEY = 'affordability-consent-v1';
export const CONSENT_UPDATED_EVENT = 'cookie-consent:updated';

function safeParseConsent(rawValue) {
  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (err) {
    console.error('Failed to parse consent preferences:', err);
    return null;
  }
}

export function getConsentPreferences() {
  return safeParseConsent(window.localStorage.getItem(CONSENT_STORAGE_KEY));
}

export function hasStoredConsent() {
  return Boolean(getConsentPreferences());
}

export function saveConsentPreferences(preferences) {
  const nextValue = {
    necessary: true,
    analytics: Boolean(preferences.analytics),
    advertising: Boolean(preferences.advertising),
    updatedAt: new Date().toISOString()
  };

  window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(nextValue));
  window.dispatchEvent(new CustomEvent(CONSENT_UPDATED_EVENT, { detail: nextValue }));
  return nextValue;
}

export function canUseAnalytics() {
  const preferences = getConsentPreferences();
  return Boolean(preferences?.analytics);
}

export function canUseAdvertising() {
  const preferences = getConsentPreferences();
  return Boolean(preferences?.advertising);
}

export function clearConsentPreferences() {
  window.localStorage.removeItem(CONSENT_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(CONSENT_UPDATED_EVENT, { detail: null }));
}